import {ChangeStateRequest} from '@//common/api';
import {createEndpoint} from '@/logged/config';

export const asideMenuEndpoints = () => ({
    updateNavBarState: createEndpoint<void, ChangeStateRequest>('changeNavbarState'),
});
